const modalConfig = {
  popup: "swal-popup",
  header: "swal-header",
  title: "swal-title",
  content: "swal-content",
  confirmButton: "swal-confirmButton",
  cancelButton: "swal-cancelButton",
  denyButton: "swal-denyButton",
  loader: "swal-loader",
};

export default modalConfig;
